import type { IOptimizeImageOptions } from '@/composables/elements.client'

type OptimizeImageOption = keyof IOptimizeImageOptions

export function parseImageKitOptions(options: IOptimizeImageOptions) {
  const optionsAbbreviations: Record<OptimizeImageOption, string> = {
    width: 'w',
    height: 'h',
    aspectRatio: 'ar',
    quality: 'q',
    blur: 'bl',
    backgroundColor: 'bg',
    crop: 'c',
    focus: 'fo',
    format: 'f',
  }

  const queries: string[] = []
  Object.entries(options).forEach(([key, value]) => {
    if (!value)
      return

    const formattedValue = typeof value === 'number' ? Math.round(value) : value
    const queryValue = Array.isArray(value) ? value.join('-') : formattedValue

    const abbreviation = optionsAbbreviations[key as OptimizeImageOption]
    const query = `${abbreviation}-${queryValue}`

    queries.push(query)
  })

  return queries.length ? `/tr:${queries.join(',')}` : null
}

export default defineNuxtPlugin(() => {})
